<div class="ical-container">
  <span class="text-sm font-bold">{{ project?.Name }} Only</span>
  <div class="webcal-link">
    <a [href]="iCalLink" target="_blank" class="text-sm text-primary leading-3">{{ iCalLink }}</a>
  </div>
  <div class="flex justify-start items-start">
    <button pButton (click)="onCopy()" [cdkCopyToClipboard]="iCalLink" [label]="copyLabel" class=""></button>
  </div>
  <ng-container *ngIf="project?.Projects?.length">
    <span class="text-sm font-bold mt-4">{{ project?.Name }} and subprojects</span>
    <div class="webcal-link">
      <a [href]="iCalSubprojectLink" target="_blank" class="text-sm text-primary leading-3">{{ iCalSubprojectLink }}</a>
    </div>
    <div class="flex justify-start items-start">
      <button pButton (click)="onCopy()" [cdkCopyToClipboard]="iCalSubprojectLink" [label]="copyLabel" class=""></button>
    </div>
  </ng-container>
</div>
